import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRuntimeStore } from "@/store/runtime"

// import { v4 as uuidv4 } from 'uuid';




export const useDataStore = defineStore('dataStore', () => {


  const trackerTodayName = (() => {

    let today = new Date()
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    today = localISOTime.split('T')[0]

    return today
  })()

  const timers = {
    dayFeature: {
      delete: {
        text: "20 giorni",
        desc: "tempo necessario a cancellare le features in day layers",
        value: 20,
      },
      send: {
        value: 1,
        text: "1 giorno",
        desc: "tempo necessario a cancellare le features in day layers"
      }
    },
    // dayFeatureMedia: {
    //   delete: {
    //     text: "20 giorni",
    //     value: 20,
    //   },
    //   send: {
    //     value: 1,
    //     text: "1 giorno",
    //   }
    // },
    journalDay: {
      delete: {
        text: "100 giorni",
        value: 100,
      },
      send: {
        value: 10,
        text: "10 giorni",
      }
    }
  }



  const save = () => {
    localStorage.setItem("data", JSON.stringify(data.value))
    console.log("🍰 ", "💾 data saved (to localStorage)")
  }

  // console.log("🍰 ", "activate delete next line")
  const deletionEnabled = true

  const runtimeStore = useRuntimeStore();

  const data = ref({})

  const userPk = runtimeStore?.session?.user?.pk
  if (!userPk) {
    console.log("🍰 ", "👤 userPk not found")
    return { data }
  }
  console.log("🍰 ", "👤 userPk " + userPk)
  
  if (localStorage.getItem("data")) {
    data.value = JSON.parse(localStorage.getItem("data"))
  }

  if (!data.value?.[userPk]) {      // default per user
    data.value[userPk] = {
      tracker: {
        days: {
          // "1970-01-01": some1970TestData,
        },
        journal: {
          // "2023-10-4": {
          //   text: "asd",
          // },
          // "2023-10-10": {
          //   text: "asd2",
          // },
        }
      },
      phytosociological: {
        visible: false,
        name: "phytosociological",
        type: "FeatureCollection",
        features: []
      },
      annotazioni_personali: {
        visible: true,
        name: "annotazioni_personali",
        type: "FeatureCollection",
        features: []
      },
      annotazioni_colleghi: {
        visible: true,
        name: "annotazioni_colleghi",
        type: "FeatureCollection",
        features: []
      }
    }
    save()
  }

  for (const [day_name, the_day] of Object.entries(data.value[userPk].tracker.days)) {
    // console.log("🍰 ",the_day)
    if (trackerTodayName != day_name) {
      the_day.visible = false
    }
  }




  const theOptions = [

    {
      id: "phytosociological",
      geometryType: "Point",
      targetLayer: "phytosociological",
      modelCamel: "PhytoSociological",
      descrizione: "Fito sociologica",
      color: "#E65100",
      emoji: "💐",
      glyph: "󰍎",
      mdiIcon: "map-marker",
      group_needed: "ufficio_botanico"
    },

    // {
    //   id: "starred",
    //   geometryType: "Point",
    //   targetLayer: "today",
    //   modelCamel: "SegnalazioneAnnotazione",
    //   descrizione: "Annotazione",
    //   color: "#e6e600",
    //   emoji: "⭐️",
    //   glyph: "★",
    //   mdiIcon: "star",
    //   group_needed: "ufficio_botanico"
    // },

    {
      id: "segnalazione_fauna",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneFauna",
      descrizione: "Fauna",
      color: "#4E342E",
      emoji: "🐐",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_flora_pngp",  // utilizziamo pngp per entramnbi
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneFlora",
      descrizione: "Flora",
      color: "#33691E",
      emoji: "🌺",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    // {
    //   id: "segnalazione_flora_vda",
    //   geometryType: "Point",
    //   targetLayer: "today",
    //   modelCamel: "SegnalazioneFlora",
    //   descrizione: "Flora VdA",
    //   color: "#33691E",
    //   emoji: "🌺",
    //   glyph: "󰍎",
    //   mdiIcon: "map-marker",
    //   group_needed: "ufficio_botanico",
    //   props: {
    //     area: "vda"
    //   }
    // },
    {
      id: "segnalazione_generica",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneGenerica",
      descrizione: "Generica",
      color: "#616161",
      emoji: "📍",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_persona",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazionePersona",
      descrizione: "Persona",
      color: "#AD1457",
      emoji: "👨‍🦱",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_veicolo",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneVeicolo",
      descrizione: "Veicolo",
      color: "#4527A0",
      emoji: "🚙",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_marcati",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneMarcati",
      descrizione: "Marcati",
      color: "#C62828",
      emoji: "🔣",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_lupo",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneLupo",
      descrizione: "Lupo",
      color: "#607D8B",
      emoji: "🐺",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_gipeto",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneGipeto",
      descrizione: "Gipeto",
      color: "#01579B",
      emoji: "🦅",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_interesse",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazionePuntointeresse",
      descrizione: "Punto d'interesse",
      color: "#E0E0E0",
      emoji: "🔎",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },
    {
      id: "segnalazione_tabellazione",
      geometryType: "Point",
      targetLayer: "today",
      modelCamel: "SegnalazioneTabellazione",
      descrizione: "Tabellazione",
      color: "#FBC02D",
      emoji: "🪧",
      glyph: "󰍎",
      mdiIcon: "map-marker",
    },

    // {
    //   id: "segmento",
    //   geometryType: "LineString",
    //   targetLayer: "today",
    //   modelCamel: "Segmento",
    //   descrizione: "Segmento ",
    //   color: "#616161",
    //   emoji: "🐌",
    //   glyph: "󰕡",
    //   mdiIcon: "vector-polyline",
    // },

    {
      id: "segmentolupo",
      geometryType: "LineString",
      targetLayer: "today",
      modelCamel: "SegmentoLupo",
      descrizione: "Segmento Lupo",
      color: "#607D8B",
      emoji: "🐺",
      glyph: "󰕡",
      mdiIcon: "vector-polyline",
    },

    {
      id: "segmentodescritto",
      geometryType: "LineString",
      targetLayer: "today",
      modelCamel: "SegmentoDescritto",
      descrizione: "Segmento Descritto",
      color: "#C62828",
      emoji: "🐌",
      glyph: "󰕡",
      mdiIcon: "vector-polyline",
    },

    {
      id: "segmentomanutenzione",
      geometryType: "LineString",
      targetLayer: "today",
      modelCamel: "SegmentoManutenzione",
      descrizione: "Segmento Manutenzione",
      color: "#FBC02D",
      emoji: "🐌",
      glyph: "󰕡",
      mdiIcon: "vector-polyline",
    },

    {
      id: "segmentofronteghiacciaio",
      geometryType: "LineString",
      targetLayer: "today",
      modelCamel: "SegmentoFronteGhiacciaio",
      descrizione: "Segmento Fronte Ghiacciaio",
      color: "#BBDEFB",
      emoji: "🐌",
      glyph: "󰕡",
      mdiIcon: "vector-polyline",
    },
    {
      id: "segnalazionepoligonomonticanti",
      geometryType: "Polygon",
      targetLayer: "today",
      modelCamel: "SegnalazionePoligonoMonticanti",
      descrizione: "Monticanti",
      color: "#e5c009",
      emoji: "🟫",
      glyph: "󰀁",
      mdiIcon: "vector-square",
    },   
    {
      id: "segnalazionepoligonodanni",
      geometryType: "Polygon",
      targetLayer: "today",
      modelCamel: "SegnalazionePoligonoDanni",
      descrizione: "Danni",
      color: "#dd2a08",
      emoji: "🟫",
      glyph: "󰀁",
      mdiIcon: "vector-square",
    },
  ]

  

  const ventaglio_possibili = computed(() => {

    return theOptions.filter(elem => {
      // debugger
      if (elem?.group_needed) {
        if (runtimeStore.session.user.is_superuser) return true
        if (runtimeStore.session.user.groups.includes(elem.group_needed)) return true
        else return false
      }
      return true
    })
  })


  console.log(ventaglio_possibili.value)

  if (Object.keys(runtimeStore.session.settings?.showInsertType).length === 0) {
    const showInsertType = {}

    console.log(Object.keys(runtimeStore.session.settings?.showInsertType))
    console.log(runtimeStore.session.settings?.showInsertType)
    console.log(ventaglio_possibili.value)

    for (const option of ventaglio_possibili.value) {
      showInsertType[option.id] = true
    }
    runtimeStore.session.settings.showInsertType = showInsertType
    runtimeStore.saveSession()
  }

  

  
  const userData = computed(() => data.value[userPk])


  const isLayerSynced = (the_day) => {
    if (the_day?.state !== 201) return false
    return true
  }



  const isLayerEmpty = (the_day) => {
    if (the_day?.features.length === 0) return true
    return false
  }


  const isDateOldEnough = (day, days) => {
    const today = new Date()
    const the_date = new Date(day)
    today.setHours(0, 0, 0, 0)
    the_date.setHours(0, 0, 0, 0)
    const msInDay = 24 * 60 * 60 * 1000;
    const pastdiff = Math.floor((today - the_date) / msInDay)
    if (pastdiff > days) {
      return true
    }
    return false
  }


  const isLayerOldEnoughToBeDeleted = (day_name) => {
    const timer = timers.dayFeature.delete.value
    return isDateOldEnough(day_name, timer)
  }

  const isJournalDayOldEnoughToBeTransferred = (day_name) => {
    const timer = timers.journalDay.send.value
    return isDateOldEnough(day_name, timer)
  }

  const isJournalDayOldEnoughToBeDeleted = (day_name) => {
    const timer = timers.journalDay.delete.value
    return isDateOldEnough(day_name, timer)
  }


  const isJournalDayAlreadyTransferred = (the_day) => {
    if (the_day?.state === 201 || the_day?.state === 409) {
      return true
    }
    return false
  }





  const journalDaysToBeTransferred = computed(() => {
    const journalDaysToBeTransferred = {}

    for (const [day_name, the_day] of Object.entries(userData.value.tracker.journal)) {
      if (!isJournalDayAlreadyTransferred(the_day)) {

        if (isJournalDayOldEnoughToBeTransferred(day_name)) {
          // should be locked in write in UI
          journalDaysToBeTransferred[day_name] = the_day
        }

      }
    }
    return journalDaysToBeTransferred
  })

  const featuresToBeTransferred = computed(() => {

    const featuresToBeTransferred = {
      segnalazioni: [],
      tracce: [],
    }

    // notSyncedDays should not include today
    const notSyncedDays = Object.entries(userData.value.tracker.days).filter(day => {

      // check on key
      if (day[0] === trackerTodayName) return false

      // check on value
      if (isLayerSynced(day[1])) return false
      return true

    })


    for (const [day_name, the_day] of notSyncedDays) {
      day_name == true // to avoid warning

      for (const feature of the_day.features) {
        const statesToAvoid = [201, 409, 422]
        if (!statesToAvoid.includes(feature?.properties?.state))
          featuresToBeTransferred.segnalazioni.push(feature)
      }
    }
    return featuresToBeTransferred
  })

  const needToTransfer = computed(() => {
    console.log("🍰 ", "👉 todo: aggiungere anche gli altri checks, sui media, sui tracciati e sulle giornate")

    const thingsToBeTransferredLength =
      featuresToBeTransferred.value.segnalazioni.length +
      journalDaysToBeTransferred.value.length

    return thingsToBeTransferredLength > 0
  })



  const deleteAllUsersData = () => {
    data.value = {}
    save()
  }

  const deleteUserData = () => {
    delete data.value[userPk]
    save()
  }

  const copyTrackerFeature = (uuid) => {
    const { node, feature } = getDataFromFeatureUUID(uuid)
    const newFeature = JSON.parse(JSON.stringify(feature))
    newFeature.properties.uuid = crypto.randomUUID()
    node.features.push(newFeature)
    save()
    return newFeature
  }


  const addTrackerFeature = (featuredata) => {   // today or phytosociological

    // find first in  ventaglio whhere model == featuredata.properties.model

    const possibilita = ventaglio_possibili.value.find((item) => item.modelCamel === featuredata.properties.model)
    if (!possibilita) {
      console.log("🍰 ", "model not found", featuredata.properties.model)
      console.log("🍰 ", "ventaglio", ventaglio_possibili.value)
      console.log("🍰 ", "featuredata", featuredata)
      console.log("🍰 ", "featuredata.properties.model", featuredata.properties.model)
      return false
    }

    let targetNode = null
    let mapTargetLayerName = ""


    if (possibilita.targetLayer == "today") {
      if (!(trackerTodayName in userData.value.tracker.days)) {
        console.log("🍰 ", "🍍 creating layer", trackerTodayName)

        userData.value.tracker.days[trackerTodayName] = {
          type: "FeatureCollection",
          features: [],
          visible: true,
          name: trackerTodayName,
          zIndex: 1000,
        }
      }
      mapTargetLayerName = trackerTodayName
      targetNode = userData.value.tracker.days[trackerTodayName]
    }
    if (possibilita.targetLayer == "phytosociological") {
      if (!("phytosociological" in userData.value)) {
        userData.value.phytosociological = []
      }
      mapTargetLayerName = "phytosociological"
      targetNode = userData.value.phytosociological
    }


    featuredata.properties.uuid = crypto.randomUUID();


    targetNode.features.push(featuredata)

    save()

    return {
      uuid: featuredata.properties.uuid,
      layerName: mapTargetLayerName
    }
  }



  const updateTrackerFeature = (featuredata, layerName) => {   // today only

    let targetNode = null

    const uuid = featuredata.properties.uuid

    console.log("🍰 ", layerName)
    console.log("🍰 ", uuid)

    if (layerName == "phytosociological") {
      targetNode = userData.value.phytosociological
    }
    else {
      targetNode = userData.value.tracker.days?.[layerName]
    }


    if (!targetNode) {
      console.error("🍍 layer not found", uuid)
      return false
    }

    const features = targetNode.features
    const index = features.findIndex((feature) => feature.properties.uuid === uuid)
    if (index === -1) {
      console.error("🍍 feature not found", uuid)
      return false
    }

    features[index] = featuredata

    save()
  }

  const getDataFeatureFromOLFeature = (olFeature, olLayer) => {

    return getDataFromFeatureUUID(olFeature.get("uuid"))
  }


  const getDataFromFeatureUUID = (uuid) => {


    for (const [day_name, the_day] of Object.entries(userData.value.tracker.days)) {
      for (const feature of the_day.features) {
        if (feature.properties.uuid === uuid) {
          // console.log("🍰 ","📅 feature found in ", day_name)
          return {
            node: the_day,
            feature: feature,
          }
        }
      }
    }

    for (const feature of userData.value.phytosociological.features) {
      if (feature.properties.uuid === uuid) {
        // console.log("🍰 ","📅 feature found in ", userData.value.phytosociological)
        return {
          node: userData.value.phytosociological,
          feature: feature,
        }
      }
    }

    return false
  }


  const checkNSetDayUploaded = (day) => {

    console.log("🍰 ","📅 checkNSetDayUploaded", day)

    const statesToCount = [201, 409]
    
    let dayIsFullyUploaded = true

    for (const feature of day.features) {

      if (!statesToCount.includes(feature.properties.state)) { 
        dayIsFullyUploaded = false
      }

      if (dayIsFullyUploaded) {
        day.state = 201
        save()
      }

    }

  }

  const deleteTrackerFeature = (olFeature, olLayer) => {   // today only

    // console.log("🍰 ",olFeature)
    // console.log("🍰 ",olLayer)
    const foundDataFeatureAndNode = getDataFeatureFromOLFeature(olFeature, olLayer)

    const node = foundDataFeatureAndNode.node
    const foundFeature = foundDataFeatureAndNode.feature


    const index = node?.features.findIndex((feature) => feature === foundFeature)

    if (index === -1) {
      console.log("🍰 ", "📅 feature not found")
      return false
    }

    node?.features.splice(index, 1)

    console.log("🍰 ", node)


    // console.log("🍰 ",node.features)
    // console.log("🍰 ",node.features.length)
    if (node?.features.length === 0) {
      if (node.name === "phytosociological") {
        // delete userData.value.phytosociological
      }
      else {
        delete userData.value.tracker.days[node.name]
      }

    }

    checkNSetDayUploaded(node)

    save()
    return true
  }


  const deleteAllPhytosociological = () => {


    console.log("🍰 ", "🍍 deleteAllPhytosociological")
    console.log("🍰 ", "🍍 ", userData.value.phytosociological.features)

    const howMany = userData.value.phytosociological.features.length


    userData.value.phytosociological.features = []
    save()

    return howMany
  }





  const ventaglio_possibili_filtered = computed(() => {
    return ventaglio_possibili.value.filter(elem => {
      return runtimeStore.session.settings?.showInsertType?.[elem.id] === true
    })
  })



  const allVisibleFeaturesGeoJson = computed(() => {

    let features = []

    for (const [day_name, the_day] of Object.entries(userData.value.tracker.days)) {
      if (the_day.visible === false) continue
      for (const feature of the_day.features) {
        features.push(feature)
      }
    }

    if (userData.value.phytosociological.visible === true) {
      for (const feature of userData.value.phytosociological.features) {
        features.push(feature)
      }
    }
    return {
      crs: { type: "EPSG", properties: { code: "4326" } },
      type: "FeatureCollection",
      features: features
    }
  })





  const deleteOldTransferredData = () => {

    // 🔍 check transferred data: segnalazioni, phytosociological, journal, ATM
    console.log("🍰 ", "🗑️ deleteOldTransferredData")

    for (const [day_name, the_day] of Object.entries(userData.value.tracker.days)) {

      if (isLayerEmpty(the_day)) {
        console.log("🍰 ", "🗑️ deleting empty day", day_name)
        if (deletionEnabled) {
          delete userData.value.tracker.days[day_name]
          save()
        }
      }

      if (isLayerSynced(the_day)) {
        // is the day old enough ? 20 days
        if (isLayerOldEnoughToBeDeleted(day_name)) {
          console.log("🍰 ", "🗑️ features day synced, old enough, deleting", day_name)
          if (deletionEnabled) {
            delete userData.value.tracker.days[day_name]
            save()
          }
        }
      }
    }


    // debugger

    for (const [day_name, the_day] of Object.entries(userData.value.tracker.journal)) {
      if (isJournalDayAlreadyTransferred(the_day)) {


        if (isJournalDayOldEnoughToBeDeleted(day_name)) {
          console.log("🍰 ", "🗑️ journal day synced, old enough, deleting", day_name)
          if (deletionEnabled) {
            delete userData.value.tracker.journal[day_name]
          }
        }

      }
    }



  }

  // console.log("🍰 ", "🍍 aggiustare sto casino col ventaglio")

  deleteOldTransferredData()





  return {
    userData,
    data,
    trackerTodayName,
    featuresToBeTransferred,
    journalDaysToBeTransferred,

    needToTransfer,

    isLayerSynced,

    save,
    deleteUserData,
    deleteAllUsersData,

    getDataFeatureFromOLFeature,
    getDataFromFeatureUUID,
    addTrackerFeature,
    copyTrackerFeature,
    deleteTrackerFeature,
    updateTrackerFeature,

    checkNSetDayUploaded,

    deleteAllPhytosociological,

    ventaglio_possibili,
    ventaglio_possibili_filtered,

    allVisibleFeaturesGeoJson,

    timers,


  }
})




